import React, { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { ADMIN_EMAILS } from '../../firebase/config';
import './Admin.css';

const AdminLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    
    try {
      setError('');
      setLoading(true);
      
      const userCredential = await login(email, password);
      
      if (ADMIN_EMAILS.includes(userCredential.user.email)) {
        navigate('/admin/dashboard');
      } else {
        setError('Accès non autorisé - Compte non administrateur');
      }
      
    } catch (error) {
      setError('Email ou mot de passe incorrect');
    }
    setLoading(false);
  }

  return (
    <div className="admin-login-container">
      <div className="admin-login-card">
        <h2>Administration SMTD</h2>
        <p>Accès réservé au personnel</p>
        
        {error && <div className="error-message">{error}</div>}
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email admin</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="admin@smtd.fr"
            />
          </div>
          
          <div className="form-group">
            <label>Mot de passe</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
          </div>
          
          <button disabled={loading} className="btn-admin" type="submit">
            {loading ? 'Connexion...' : 'Accéder au dashboard'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;